import React, { Component } from "react";
import Header from "../../layout/Header";
import BannerSimple from "../../layout/BannerSimple";
import Footer from "../../layout/Footer";
import SEO from "../../layout/SEO";
import ArticlesGrid from "../../layout/ArticlesGrid";
import { withRouter } from "react-router-dom";

class PPArticles extends Component {
  componentDidMount() {
    window.resetScript();
  }

  render() {
    return (
      <>
        <SEO
          title="Projet Personnel"
          description="Découvrez mes projets personnels et les réalisations effectuées en autonomie."
          keywords="projet personnel, PP, projets, réalisations personnelles"
        />
        <Header active="Projet Personnel" modeDark={true} />
        <BannerSimple 
          title="Projet Personnel" 
          boxElement={[
            { name: "Accueil", link: "/" },
            { name: "Projet Personnel", link: window.location.pathname }
          ]} 
        />
        
        <section className="portfolio_details_area section-gap">
          <div className="container">
            <ArticlesGrid 
              type="PP"
              itemsPerPage={12}
              emptyMessage="Aucun article de projet personnel trouvé"
            />
          </div>
        </section>

        <Footer />
      </>
    );
  }
}

export default withRouter(PPArticles);

